import { cn } from '@/lib/cn';
import { type JSX, Show } from 'solid-js';
import { DatePicker } from './DatePicker';

export interface DateRangeValue {
  start: string;
  end: string;
}

export interface DateRangePickerProps {
  value: DateRangeValue;
  onChange: (value: DateRangeValue) => void;
  label?: string;
  hint?: string;
  error?: string;
  required?: boolean;
  min?: string;
  max?: string;
  class?: string;
}

export const DateRangePicker = (props: DateRangePickerProps): JSX.Element => {
  const orderError = () =>
    props.value.start && props.value.end && props.value.start > props.value.end
      ? 'Start date must not be after end date'
      : '';
  const error = () => props.error || orderError();
  return (
    <fieldset class={cn('flex flex-col gap-1 text-sm', props.class)}>
      <Show when={props.label}>
        <legend
          class={cn(
            'font-medium text-neutral-700 dark:text-neutral-300',
            props.required && "after:ml-0.5 after:text-red-500 after:content-['*']",
          )}
        >
          {props.label}
        </legend>
      </Show>
      <div class="grid gap-2 sm:grid-cols-2">
        <DatePicker
          min={props.min}
          max={props.max}
          label="Start"
          value={props.value.start}
          onChange={(start) => props.onChange({ ...props.value, start })}
        />
        <DatePicker
          min={props.min}
          max={props.max}
          label="End"
          value={props.value.end}
          onChange={(end) => props.onChange({ ...props.value, end })}
        />
      </div>
      <Show when={error()}>
        <span class="text-xs text-red-600">{error()}</span>
      </Show>
      <Show when={!error() && props.hint}>
        <span class="text-xs text-neutral-500">{props.hint}</span>
      </Show>
    </fieldset>
  );
};
